import { useEffect, useState } from "react";
import axios from "axios";
import { APP_VERSION, BUILD_DATE, BUILD_COMMIT } from "../version";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Small muted version label. Click/hover to reveal frontend + backend
 * version side-by-side so a mismatch (cached client or half-deployed
 * server) is obvious.
 */
export const VersionBadge = ({ className = "" }) => {
  const [backend, setBackend] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/version`, { timeout: 5000 })
      .then((r) => {
        if (!cancelled) setBackend(r.data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const mismatch = backend && backend.version && backend.version !== APP_VERSION;
  const feLabel = `v${APP_VERSION} (${BUILD_DATE}${BUILD_COMMIT ? ` · ${BUILD_COMMIT}` : ""})`;
  const beLabel = backend
    ? `v${backend.version} (${backend.build_date || "?"}${backend.commit ? ` · ${backend.commit}` : ""})`
    : "loading…";
  const title = `Frontend: ${feLabel}\nBackend: ${beLabel}`;

  return (
    <span
      data-testid="version-badge"
      title={title}
      className={
        "text-[10px] tabular-nums select-none " +
        (mismatch ? "text-amber-600 font-medium" : "text-muted-foreground/70") +
        " " +
        className
      }
    >
      v{APP_VERSION}
      {mismatch && backend ? ` · be v${backend.version}` : ""}
    </span>
  );
};

export default VersionBadge;
